import { useEffect } from 'react';

interface TypeformWidgetProps {
  formId: string;
  className?: string;
}

export default function TypeformWidget({ formId, className = "" }: TypeformWidgetProps) {
  useEffect(() => {
    // Load the Typeform embed script
    const script = document.createElement('script');
    script.src = "//embed.typeform.com/next/embed.js";
    script.async = true;
    document.body.appendChild(script);

    // Cleanup on component unmount
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div className={className}>
      <div 
        data-tf-live={formId} 
        data-tf-hide-headers 
        data-tf-inline-on-mobile
        style={{ width: '100%', height: '500px' }} // Added style for better mobile layout
      >
      </div>
    </div>
  );
}